module.exports = __webpack_public_path__ + "img/chart_reduce.747aeb01.svg";